import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import KeysTable from './KeysTable';
import { wrapTemplateKey, type TemplateKeyRow } from '../keysUtils';
import { CLIENT_TEMPLATE_KEYS } from '../../model/buildObjectTemplateValueKeys';

interface ClientKeysTabProps {
    onKeySelect?: (key: string) => void;
}

const ClientKeysTab = ({ onKeySelect }: ClientKeysTabProps) => {
    const { t } = useTranslation('TemplateValueKeys');

    const rows = useMemo<TemplateKeyRow[]>(
        () =>
            CLIENT_TEMPLATE_KEYS.map((name) => ({
                key: wrapTemplateKey(name),
                value: t(`directory.client.${name}`),
            })),
        [t],
    );

    return <KeysTable rows={rows} onKeySelect={onKeySelect} />;
};

export default ClientKeysTab;
